import React, { useState, useRef, useCallback } from 'react';
import DashboardHeader from '@/components/DashboardHeader';
import GHLSetup from '@/components/GHLSetup';
import WebhookStatus from '@/components/WebhookStatus';
import StatsPanel from '@/components/StatsPanel';
import OnboardingChecklist from '@/components/OnboardingChecklist';
import BotConfig from '@/components/BotConfig';
import BotTestPanel from '@/components/BotTestPanel';
import ConversationLog from '@/components/ConversationLog';
import ActivityLog from '@/components/ActivityLog';
import AppFooter from '@/components/AppFooter';

export default function DashboardPage() {
  const [settingsRefreshKey, setSettingsRefreshKey] = useState(0);
  const crmRef = useRef(null);
  const botRef = useRef(null);

  const handleScrollTo = useCallback((section) => {
    const ref = section === 'crm' ? crmRef : section === 'bot' ? botRef : null;
    ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, []);

  return (
    <div className="min-h-screen bg-[#141414]" data-testid="dashboard-page">
      <DashboardHeader />
      <main className="max-w-[1400px] mx-auto px-6 py-6 md:py-8">
        {/* Overline */}
        <div className="mb-6">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#7B2FFF]">
            Command Center
          </span>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#EDEDF0] mt-1" style={{ fontFamily: "'Unbounded', sans-serif" }}>
            Dashboard
          </h2>
          <p className="text-sm text-[#A1A1AA] mt-1">
            Configure your AI-powered messaging automation
          </p>
        </div>

        {/* Stats Row */}
        <div className="mb-5">
          <StatsPanel />
        </div>

        {/* Onboarding Checklist */}
        <OnboardingChecklist onScrollTo={handleScrollTo} />

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {/* Row 1: GHL Setup + Webhook Status */}
          <div className="md:col-span-2" ref={crmRef}>
            <GHLSetup onSettingsChange={() => setSettingsRefreshKey((k) => k + 1)} />
          </div>
          <div className="md:col-span-1 lg:col-span-2">
            <WebhookStatus refreshKey={settingsRefreshKey} />
          </div>

          {/* Row 2: Bot Configuration */}
          <div className="md:col-span-3 lg:col-span-4" ref={botRef}>
            <BotConfig />
          </div>

          {/* Row 3: Test Your Bot */}
          <div className="md:col-span-3 lg:col-span-4">
            <BotTestPanel />
          </div>

          {/* Row 4: Conversation Log */}
          <div className="md:col-span-3 lg:col-span-4">
            <ConversationLog />
          </div>

          {/* Row 5: Activity Log */}
          <div className="md:col-span-3 lg:col-span-4">
            <ActivityLog />
          </div>
        </div>
        <AppFooter />
      </main>
    </div>
  );
}
